import {
  type PiercingBookingJourneyEventType,
  type PiercingBookingJourneyStage,
} from '../utils/piercingBookingJourney';

export type BookingJourneyPingPayload = {
  journeyId: string;
  flow?: 'PIERCING';
  stage: PiercingBookingJourneyStage;
  eventType?: PiercingBookingJourneyEventType;
  shopId?: string;
  clientId?: string;
  email?: string;
  phone?: string;
  anonymousCode?: string;
  snapshot?: {
    cart?: Array<{
      bodyZoneId?: string;
      piercingTypeId?: string;
      bodyZoneName?: string;
      piercingTypeName?: string;
      selectedSupplements?: string[];
    }>;
    availableDate?: string;
    selectedTimeSlot?: string;
    lastError?: string;
  };
};

export const bookingJourneyApi = {
  ping(payload: BookingJourneyPingPayload): void {
    if (!payload.journeyId) return;
    const body = JSON.stringify({ ...payload, flow: 'PIERCING' });
    void fetch('/api/booking-journeys/ping', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => undefined);
  },

  beacon(payload: BookingJourneyPingPayload): void {
    if (!payload.journeyId || typeof navigator === 'undefined' || !navigator.sendBeacon) {
      this.ping(payload);
      return;
    }
    const body = JSON.stringify({ ...payload, flow: 'PIERCING' });
    try {
      const blob = new Blob([body], { type: 'text/plain' });
      const sent = navigator.sendBeacon('/api/booking-journeys/beacon', blob);
      if (!sent) this.ping(payload);
    } catch {
      this.ping(payload);
    }
  },
};
